// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bee5477f","453":"db109f8c","455":"a034d71d","977":"1a367377"}[chunkId] + ".chunk.js";
};